import styled from "styled-components";
import { GRATIFICATION_FALLBACK_HEIGHT, STATE_CHANGE_DELAY } from "./constants";

export const PreStateHalfcard = styled.div<{ addingSuperToCart: boolean }>(({ addingSuperToCart }) => ({
    background: "none",
    animation: `${addingSuperToCart ? "sleep" : ""} ${STATE_CHANGE_DELAY}ms forwards`,

    "@keyframes sleep": {
        "0%": { opacity: 1 },
        "100%": { opacity: 0 },
    },
}));

export const PostStateHalfcard = styled.div<{ height: number }>(({ height }) => ({
    background: "none",
    animation: `wakeUp ${STATE_CHANGE_DELAY}ms forwards`,
    height: `calc(var(--sab, 0px) + ${height || GRATIFICATION_FALLBACK_HEIGHT}px)`,

    "@keyframes wakeUp": {
        "0%": { opacity: 0 },
        "100%": { opacity: 1 },
    },
}));

export const CloseIconContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.medium,
    right: theme.spacing.medium,
    zIndex: 1,
}));
